:host {
  display: none;
  width: 100%;
  height: 100%;
  background-color: var(--white-layout-300-primary);
}

:host([data-is-visible]) {
  display: block;
}

.wrapper {
  flex-direction: column;
  background: var(--white-layout-301-level-0-elevation);
}

.header,
.content,
.footer {
  width: 100%;
}

.content {
  flex: 1;
  min-height: 200px;
}

.footer {
  display: flex;
  align-self: flex-end;
  box-shadow: 0px 0px 4px var(--chart-104-pressed);
  background-color: var(--white-layout-301-level-0-elevation);
  padding: calc(1.75 * var(--spacer)) calc(5 * var(--spacer));
  z-index: 10;

  &--button {
    margin-right: calc(2 * var(--spacer));

    &#btnCancel {
      margin-left: auto;
      margin-right: 0;
    }
  }
}
